import { Component, OnInit, inject, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { RouterModule } from '@angular/router';

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

@Component({
  selector: 'app-cookie-banner',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './cookie-banner.component.html',
  styleUrls: ['./cookie-banner.component.scss'],
})
export class CookieBannerComponent implements OnInit {
  private platformId = inject(PLATFORM_ID);
  
  isVisible = false;

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      const consent = localStorage.getItem('cm_cookie_consent');
      if (!consent) {
        // Small delay so it animates in smoothly after initial load
        setTimeout(() => {
          this.isVisible = true;
        }, 800);
      }
    }
  }

  acceptAll(): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('cm_cookie_consent', 'accepted');
      if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('consent', 'update', {
          ad_storage: 'granted',
          ad_user_data: 'granted',
          ad_personalization: 'granted',
          analytics_storage: 'granted',
        });
      }
      this.isVisible = false;
    }
  }

  acceptEssential(): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('cm_cookie_consent', 'essential');
      if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('consent', 'update', {
          ad_storage: 'denied',
          ad_user_data: 'denied',
          ad_personalization: 'denied',
          analytics_storage: 'denied',
        });
      }
      this.isVisible = false;
    }
  }
}
